<template>
  <!-- Container -->
  <div class="roles-type-container">

    <div class="profile-show-read-only-container" v-if="readOnly">
      <div class="profile-show-read-only-label"><strong>Profil</strong></div>
      <ul>
        <li v-for="(role, index) in selected" :key="index">
          {{ getUserProfileClone()._embedded.roles_enumeration[role] }}
        </li>
      </ul>
    </div>
    <!-- Form -->
    <b-form @submit="patchRoles" :id="`app-roles-user-form${_uid}`" v-else>

      <b-form-group label="Profil">

        <!-- CheckBox -->
        <b-form-checkbox-group id="rolesCheckboxes"
                               name="roles[]"
                               v-model="selected"
                               :options="rolesEnumeration">
        </b-form-checkbox-group>

        <!-- Alert -->
        <ValidationErrorAlert :form-error-list="getFormError" />

      </b-form-group>

      <!-- Submit -->
      <b-button type="submit"
                :form="`app-roles-user-form${_uid}`"
                variant="primary"
                v-if="getUserRolesCloneUpdated()">
        Sauvegarder
      </b-button>

    </b-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RolesType',
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      rolesEnumeration: 'getRolesEnumeration',
    }),
    selected: {
      get() {
        let value = [];
        if (this.getUserRolesClone().length > 0) {
          value = this.getUserRolesClone();
        }
        value = this.getUserProfileClone().roles;
        return value;
      },
      set(value) {
        this.$store.commit('setUserRolesClone', value);
      },
    },
    getFormError() {
      return this.getFormRolesUserError() || [];
    },
  },
  methods: {
    ...mapGetters([
      'getUserRolesCloneUpdated',
      'getUserRolesClone',
      'getUserProfileClone',
      'getFormRolesUserError',
    ]),
    patchRoles(event) {
      event.preventDefault();
      event.stopPropagation();
      this.$store.commit('setGlobalSpinnerShow', true);
      this.$store.dispatch('patchRoles')
        .then((userUpdated) => {
          // Show success toast
          const toast = {
            show: true,
            message: 'Modification des roles effectuée avec succès !',
            variant: 'success',
            duration: 3000,
          };
          this.$store.commit('setGlobalToaster', toast);
          this.$store.commit('setUserProfileClone', userUpdated);
          this.$emit('rolesUpdated');
        }, (error) => {
          // Update error form in store
          this.$store.commit('setFormRolesUserError', error);
        })
        .finally(() => {
          this.$store.commit('setGlobalSpinnerShow', false);
        })
      ;
    },
  },
  destroyed() {
    this.$store.commit('setFormRolesUserError', []);
    this.$store.commit('setUserRolesCloneUpdated', false);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/user/RolesType.vue